<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <div class="row">
        <span class="text-gray font-weight-normal">
          {{ data.label }}
        </span>
      </div>
      <div class="stacked-bar-graph row h-auto">
        <div
          :class="{
            'col-md-9': !isReport,
            'col-9': isReport,
          }"
          class="pl-0 pr-4"
        >
          <span
            v-if="correctPercent > 0"
            :style="{
              width:
                'calc(' +
                correctPercent +
                '% + ' +
                correctPercentPadding +
                'px)',
            }"
            class="bar-1"
          >
          </span>
          <span
            v-if="incorrectPercent > 0"
            :style="{
              width:
                'calc(' +
                incorrectPercent +
                '% + ' +
                incorrectPercentPadding +
                'px)',
              'margin-left': incorrectPercent <= 10 ? '-10px' : '0px',
            }"
            class="bar-2"
          >
          </span>
          <span
            v-if="notAnsweredPercent > 0"
            :style="{
              width:
                'calc(' +
                notAnsweredPercent +
                '% + ' +
                notAnsweredPercentPadding +
                'px)',
            }"
            class="bar-3"
          >
          </span>
        </div>
        <div
          :class="{
            'col-md-3': !isReport,
            'col-3': isReport,
          }"
        >
          <div class="row nowrap">
            <div
              :class="{ lightBorderReport: isReport }"
              class="text-secondary elevation-1 circle col-4"
            >
              <p class="text-barlow-condensed">{{ correctPercent }}%</p>
            </div>
            <div
              :class="{ lightBorderReport: isReport }"
              class="text-blue elevation-1 circle col-4 mx-2"
            >
              <p class="text-barlow-condensed">{{ incorrectPercent }}%</p>
            </div>
            <div
              :class="{ lightBorderReport: isReport }"
              class="text-primary elevation-1 circle col-4"
            >
              <p class="text-barlow-condensed">{{ notAnsweredPercent }}%</p>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="{ 'text-percent': !isReport }"
        class="stacked-bar-graph row col-9 pr-4"
        style="margin-top: -15px;"
      >
        <span
          v-if="correctPercent > 0"
          class="text-dark text-barlow-condensed text-left ml-n2 px-0"
          :style="{
            width:
              'calc(' +
              correctPercent +
              '% + ' +
              (correctPercent <= 5 ? '40' : '20') +
              'px)',
          }"
        >
          {{ correctPercent }} %
        </span>
        <span
          v-if="incorrectPercent > 0"
          class="text-dark text-barlow-condensed px-0"
          :class="{
            'text-right': correctPercent <= 5 && incorrectPercent <= 10,
            'text-left': incorrectPercent <= 10,
            'text-center': incorrectPercent > 10,
            'ml-3': incorrectPercent > 12,
          }"
          :style="{
            width:
              'calc(' +
              incorrectPercent +
              '% + ' +
              (incorrectPercent <= 5 ? '40' : '20') +
              'px)',
          }"
        >
          {{ incorrectPercent }} %
        </span>
        <span
          v-if="notAnsweredPercent > 0"
          :class="{ 'ml-3': notAnsweredPercent <= 10 }"
          class="text-dark text-barlow-condensed text-right px-0"
          :style="{
            width:
              'calc(' +
              notAnsweredPercent +
              '% + ' +
              (notAnsweredPercent <= 10 ? '35' : '25') +
              'px)',
            'margin-left': '25px !important',
          }"
        >
          {{ notAnsweredPercent }} %
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HorizontalStackedBar",
  props: ["data", "isReport"],
  computed: {
    total() {
      return parseInt(
        this.data.correct + this.data.incorrect + this.data.notAnswered
      );
    },
    percentView() {
      return 100 / this.total;
    },
    correctPercent() {
      if (this.data.correct) {
        return this.hideDec(
          (this.percentView * parseInt(this.data.correct)).toFixed(2)
        );
      } else {
        return 0;
      }
    },
    incorrectPercent() {
      if (this.data.incorrect) {
        return this.hideDec(
          (this.percentView * parseInt(this.data.incorrect)).toFixed(2)
        );
      } else {
        return 0;
      }
    },
    notAnsweredPercent() {
      if (this.data.notAnswered) {
        return this.hideDec(
          (this.percentView * parseInt(this.data.notAnswered)).toFixed(2)
        );
      } else {
        return 0;
      }
    },
    correctPercentPadding() {
      if (this.correctPercent >= 5 && this.correctPercent < 90) {
        return 25;
      } else if (this.correctPercent >= 90) {
        return 10;
      } else {
        return 60;
      }
    },
    incorrectPercentPadding() {
      if (this.incorrectPercent <= 5 && this.notAnsweredPercent === 0) {
        return 50;
      } else {
        return 25;
      }
    },
    notAnsweredPercentPadding() {
      if (this.notAnsweredPercent > 90) {
        return -10;
      } else if (
        this.notAnsweredPercent <= 90 &&
        this.notAnsweredPercent >= 10
      ) {
        return 25;
      } else {
        return 40;
      }
    },
  },
  methods: {
    hideDec: num => {
      if (parseInt(num.split(".")[1]) == 0) {
        return num.split(".")[0];
      } else {
        return num;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stacked-bar-graph {
  width: 100%;
  height: 38px;
  // background: #eee;
  color: #414042;

  span {
    //height: 60%;
    box-sizing: border-box;
    float: left;
    //  color: #fff;
    font-weight: bold;
    font-family: arial, sans-serif;
    padding: 10px;
    border-radius: 20px;
    margin-right: -40px;
    color: rgba(0, 0, 0, 0);
  }

  .bar-1 {
    background: var(--color-secondary);
  }

  .bar-2 {
    background: var(--color-blue);
  }

  .bar-3 {
    background: var(--color-primary);
  }

  p {
    margin: auto; /* Important */
    text-align: center;
  }

  .circle {
    width: 65px;
    height: 65px;
    max-width: 65px;
    max-height: 65px;
    min-width: 65px;
    min-height: 65px;
    border-radius: 100px;
    display: flex;
    margin: 0 auto;
    margin-top: -22px;
  }
}

.nowrap {
  flex-wrap: nowrap;
}

@media (max-width: 768px) {
  .bootstrap-wrapper .text-percent {
    display: none;
  }
  .stacked-bar-graph.row > .col-md-3 {
    margin-top: 35px;
  }
}
</style>
